export interface FilterOption {
  key: string;
  label: string;
  searchLabel?: string;
}

export interface BaseFilterItem {
  id: string;
  type: 'dropdown' | 'checkbox' | 'button';
  label?: string;
  icon?: React.ComponentType<{ className?: string }>;
  options?: FilterOption[];
  selectedValues?: string[];
  onSelectionChange?: (values: string[]) => void;
  searchable?: boolean;
  searchPlaceholder?: string;
  checked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  onClick?: () => void;
}

export const FILTER_PRIORITY = {
  ALWAYS_VISIBLE: 1,
  DEFAULT_SCREEN: 2,
  EXTRA_LARGE_ONLY: 3,
} as const;

export interface FilterItemConfig extends BaseFilterItem {
  priority: number;
  options?: FilterOption[];
}

export interface FilterMenuItem extends BaseFilterItem {
  disabled?: boolean;
}
